function Header() {
  return (
    <div className="header">
      <h1>AddressBook</h1>
      <h6>— KEEP YOUR CONTACTS IN ORDER —</h6>
    </div>
  );
}

export default Header;
